// extracted by mini-css-extract-plugin
module.exports = {"main":"Verify_main__Qx0P_","btnSwitch":"Verify_btnSwitch__tFrsL","antdBtn":"Verify_antdBtn__nqqNl"};